<div
  class="tw-flex tw-flex-col tw-w-full tw-h-full tw-min-h-0 tw-bg-white tw-font-inter"
  [ngClass]="isDrawer() ? '' : 'tw-gap-4 tw-py-4 tw-pl-4 tw-border-0 tw-border-l tw-border-solid tw-border-gray-200'"
>
  <div
    class="tw-flex tw-gap-3 tw-w-full tw-shrink-0"
    [ngClass]="
      isDrawer()
        ? 'tw-relative tw-z-10 tw-items-center tw-bg-white tw-px-4 tw-pb-3 tw-pt-[max(12px,env(safe-area-inset-top))] tw-shadow-[0_1px_1.5px_rgba(0,0,0,0.1),0_1px_1px_rgba(0,0,0,0.1)]'
        : 'tw-items-start tw-pr-4'
    "
  >
    <div class="tw-flex tw-flex-1 tw-items-center tw-gap-2 tw-h-6 tw-min-w-0">
      <svg
        class="tw-shrink-0"
        [ngClass]="isDrawer() ? 'tw-w-3.5 tw-h-3.5' : 'tw-w-4 tw-h-4'"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8 7.57895C10.2941 7.57895 12.1538 5.88234 12.1538 3.78947C12.1538 1.69661 10.2941 0 8 0C5.70589 0 3.84615 1.69661 3.84615 3.78947C3.84615 5.88234 5.70589 7.57895 8 7.57895Z" fill="#374151"/>
        <path d="M9.38462 8.42105H6.61538C5.39176 8.42239 4.21867 8.86643 3.35343 9.65576C2.4882 10.4451 2.00147 11.5153 2 12.6316V15.1579C2 15.3812 2.09725 15.5954 2.27036 15.7534C2.44347 15.9113 2.67826 16 2.92308 16H13.0769C13.3217 16 13.5565 15.9113 13.7296 15.7534C13.9027 15.5954 14 15.3812 14 15.1579V12.6316C13.9985 11.5153 13.5118 10.4451 12.6466 9.65576C11.7813 8.86643 10.6082 8.42239 9.38462 8.42105Z" fill="#374151"/>
      </svg>
      <h2
        class="tw-m-0 tw-truncate tw-text-base tw-font-semibold tw-leading-normal tw-font-inter"
        [ngClass]="isDrawer() ? 'tw-text-gray-700' : 'tw-text-gray-900'"
      >
        Full details
      </h2>
    </div>

    <button
      type="button"
      aria-label="Close"
      class="tw-flex tw-items-center tw-shrink-0 tw-bg-transparent tw-border-0 tw-cursor-pointer"
      [ngClass]="isDrawer() ? 'tw-w-8 tw-h-8 tw-justify-end tw-p-0' : 'tw-w-6 tw-h-6 tw-justify-center tw-p-1'"
      (click)="close.emit()"
    >
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.20988 6L11.7388 1.47109C11.8205 1.39216 11.8857 1.29775 11.9305 1.19336C11.9754 1.08896 11.999 0.976687 12 0.863076C12.001 0.749464 11.9793 0.636794 11.9363 0.531639C11.8933 0.426484 11.8297 0.33095 11.7494 0.250611C11.669 0.170273 11.5735 0.106739 11.4684 0.0637164C11.3632 0.020694 11.2505 -0.000954946 11.1369 3.23065e-05C11.0233 0.00101956 10.911 0.0246235 10.8066 0.0694668C10.7023 0.11431 10.6078 0.179495 10.5289 0.261217L6 4.79012L1.47109 0.261217C1.30972 0.105355 1.09358 0.0191112 0.869234 0.0210607C0.644888 0.0230102 0.430283 0.112997 0.27164 0.27164C0.112997 0.430283 0.0230102 0.644888 0.0210607 0.869234C0.0191112 1.09358 0.105355 1.30972 0.261217 1.47109L4.79012 6L0.261217 10.5289C0.179495 10.6078 0.11431 10.7023 0.0694668 10.8066C0.0246235 10.911 0.00101956 11.0233 3.23065e-05 11.1369C-0.000954946 11.2505 0.020694 11.3632 0.0637164 11.4684C0.106739 11.5735 0.170273 11.669 0.250611 11.7494C0.33095 11.8297 0.426484 11.8933 0.531639 11.9363C0.636794 11.9793 0.749464 12.001 0.863076 12C0.976687 11.999 1.08896 11.9754 1.19336 11.9305C1.29775 11.8857 1.39216 11.8205 1.47109 11.7388L6 7.20988L10.5289 11.7388C10.6903 11.8946 10.9064 11.9809 11.1308 11.9789C11.3551 11.977 11.5697 11.887 11.7284 11.7284C11.887 11.5697 11.977 11.3551 11.9789 11.1308C11.9809 10.9064 11.8946 10.6903 11.7388 10.5289L7.20988 6Z" fill="#6B7280"/>
      </svg>
    </button>
  </div>

  <div
    class="source-details-scroll tw-flex tw-flex-col tw-flex-1 tw-min-h-0 tw-overflow-y-auto tw-overscroll-contain tw-text-sm tw-leading-normal"
    [ngClass]="isDrawer() ? 'tw-gap-3 tw-py-4 tw-pl-4 tw-pr-3.5 tw-mr-0.5' : 'tw-gap-4 tw-pr-2 tw-mr-0.5'"
  >
    <div class="tw-flex tw-flex-col tw-gap-1">
      <p class="tw-m-0 tw-font-medium tw-text-gray-500 tw-font-inter tw-text-sm">Source</p>
      <p class="tw-m-0 tw-font-semibold tw-text-gray-700 tw-break-words tw-font-inter tw-text-sm">{{ sourceLabel() || '-' }}</p>
    </div>

    @if (personaName()) {
      <hr class="tw-m-0 tw-w-full tw-border-0 tw-border-t tw-border-solid tw-border-gray-200" />
      <div class="tw-flex tw-flex-col tw-items-start tw-gap-1">
        <p class="tw-m-0 tw-font-medium tw-text-gray-500 tw-font-inter tw-text-sm">Persona</p>
        <span class="tw-inline-flex tw-items-center tw-justify-center tw-min-w-10 tw-max-w-full tw-h-5 tw-px-2.5 tw-py-0.5 tw-rounded tw-bg-gray-200 tw-text-xs tw-font-medium tw-text-gray-900 tw-font-inter">
          <app-truncation-tooltip [text]="personaName()" />
        </span>
      </div>
    }

    @if (loading()) {
      @for (row of skeletonRows; track row) {
        <hr class="tw-m-0 tw-w-full tw-border-0 tw-border-t tw-border-solid tw-border-gray-200" />
        <div class="tw-flex tw-flex-col tw-gap-2 tw-animate-pulse">
          <div class="tw-h-3.5 tw-w-20 tw-rounded tw-bg-gray-200"></div>
          <div class="tw-h-3.5 tw-w-40 tw-rounded tw-bg-gray-200"></div>
        </div>
      }
    } @else {
      @for (row of fieldRows(); track row.key) {
        <hr class="tw-m-0 tw-w-full tw-border-0 tw-border-t tw-border-solid tw-border-gray-200" />
        <div class="tw-flex tw-flex-col tw-gap-1">
          <p class="tw-m-0 tw-font-medium tw-text-gray-500 tw-font-inter tw-text-sm">{{ row.label }}</p>
          <p class="tw-m-0 tw-font-semibold tw-text-gray-700 tw-break-words tw-font-inter tw-text-sm">{{ row.value || '-' }}</p>
        </div>
      } @empty {
        <hr class="tw-m-0 tw-w-full tw-border-0 tw-border-t tw-border-solid tw-border-gray-200" />
        <p class="tw-m-0 tw-font-medium tw-text-gray-500 tw-font-inter tw-text-sm">No source data available.</p>
      }
    }
  </div>
</div>
